import React from 'react';

import { IconButton } from '../../../components/common';

interface MobileShellLauncherProps {
    onOpenNavigation: () => void;
}

export const MobileShellLauncher: React.FC<MobileShellLauncherProps> = ({ onOpenNavigation }) => (
        <div className="fixed top-4 left-4 z-30 print:hidden pt-[env(safe-area-inset-top)]">
            <IconButton
                className="flex h-11 min-h-[44px] w-11 min-w-[44px] items-center justify-center overflow-hidden rounded-full border border-gray-200 bg-white p-0! shadow-lg dark:border-border-dark dark:bg-surface-dark"
                data-testid="mobile-shell-launcher"
                icon="menu"
                label="Open navigation"
                onClick={onOpenNavigation}
                size="lg"
                variant="secondary"
            />
        </div>
    );
